import { render, staticRenderFns } from "./visit-reservation.vue?vue&type=template&id=68005bd8&scoped=true&"
import script from "./visit-reservation.vue?vue&type=script&lang=js&"
export * from "./visit-reservation.vue?vue&type=script&lang=js&"
import style0 from "./visit-reservation.vue?vue&type=style&index=0&id=68005bd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68005bd8",
  null
  
)

export default component.exports